import { FunctionalComponent, h } from '@stencil/core';
import { host } from '../shared/config'
import { humanFileSize } from '../shared/helpers'

interface SectionDownloads {
    __component?: string;
    data?: any;
}


export const SectionDownloads: FunctionalComponent<SectionDownloads> = ({ data }) => {

    const { Title, Downloads } = data;
    const files = (Downloads.data && Downloads.data.map((d) => d.attributes)) || [];
    const getIcon = (ext)=>{
        switch(ext){
            case '.pdf': return 'file-pdf';
            case '.txt': return 'file-text';
            case '.docx': return 'file-text';
            case '.jpeg': return 'image';
            case '.jpg': return 'image';
            case '.svg': return 'image';
            case '.png': return 'image';
            case '.mp4': return 'play-circle';
            case '.wav': return 'play-circle';
            default: return 'pull'
        }
    }

    return [
        <section class='uk-section'>
            <div class="uk-container">
                <h2 class="uk-heading-large wsio-darker-green">{Title}</h2>
                <div class='uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-match' uk-grid>
                    {
                        files.map(({ ext, name, size, url }) =>
                            <div>
                                <div class="uk-muted-striped uk-padding uk-text-center uk-flex uk-flex-column uk-position-relative uk-overflow-hidden">
                                    <div class="uk-position-relative">
                                        <div>
                                            <span class="uk-download-icon" uk-icon={`icon:${getIcon(ext)};ratio:7;`}></span>
                                        </div>
                                        <div class="uk-margin-top">
                                            {name}
                                        </div >
                                        <div class="uk-margin-small-top uk-flex-1">
                                            {humanFileSize(size * 1000)}
                                        </div>
                                        <div class="uk-margin-top">
                                            <a target='_blank' class="uk-button uk-button-primary" href={`${host}${url}`} download>Download</a>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        )
                    }
                </div>
            </div>
        </section >
    ]
};